import { render, staticRenderFns } from "./HealthQuestionnaireForm.vue?vue&type=template&id=70104970&scoped=true&"
import script from "./HealthQuestionnaireForm.vue?vue&type=script&lang=js&"
export * from "./HealthQuestionnaireForm.vue?vue&type=script&lang=js&"
import style0 from "./HealthQuestionnaireForm.vue?vue&type=style&index=0&id=70104970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70104970",
  null
  
)

export default component.exports